module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section",
    attrs: {
      "id": "assignments"
    }
  }, [(_vm.student && _vm.student.deleted) ? _c('article', {
    staticClass: "message is-danger"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v(_vm._s(_vm.tokens['msg_removed_account']))])]) : _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_assignments']))]), _c('div', {
    staticClass: "panel-block"
  }, [(_vm.assignments === null) ? _c('div', {
    staticClass: "container"
  }, [_c('loading')], 1) : (!_vm.assignments.length) ? _c('div', {
    staticClass: "container"
  }, [_c('i', [_vm._v(_vm._s(_vm.tokens['msg_no_assignments']))])]) : _c('div', {
    staticClass: "tile is-ancestor"
  }, _vm._l((_vm.assignments), function(assignment) {
    return _c('div', {
      staticClass: "tile is-parent"
    }, [_c('div', {
      staticClass: "tile is-child"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('header', {
      staticClass: "card-header notification is-info is-paddingless"
    }, [_c('div', {
      staticClass: "card-header-title"
    }, [_vm._v(_vm._s(assignment.cls.name))]), _c('div', {
      staticClass: "card-header-icon"
    }, [(assignment.task.syllab.language) ? _c('span', {
      staticClass: "icon",
      attrs: {
        "title": _vm.tokens['tit_syllab']
      }
    }, [_c('i', {
      staticClass: "fa fa-ellipsis-h"
    })]) : _vm._e(), (assignment.task.speech.language) ? _c('span', {
      staticClass: "icon",
      attrs: {
        "title": _vm.tokens['tit_voice']
      }
    }, [_c('i', {
      staticClass: "fa fa-headphones"
    })]) : _vm._e(), (assignment.task.recordAudio) ? _c('span', {
      staticClass: "icon",
      attrs: {
        "title": _vm.tokens['tit_rec']
      }
    }, [_c('i', {
      staticClass: "fa fa-microphone"
    })]) : _vm._e()])]), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(_vm._s(assignment.task.name))])]), _c('div', {
      staticClass: "card-footer"
    }, [_c('a', {
      staticClass: "card-footer-item",
      on: {
        "click": function($event) {
          _vm.start(assignment)
        }
      }
    }, [_vm._v(_vm._s(_vm.tokens['start']))])])])])])
  }))])]), _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_completed']))]), _c('div', {
    staticClass: "panel-block"
  }, [(_vm.sessions === null) ? _c('div', {
    staticClass: "container"
  }, [_c('loading')], 1) : (!_vm.sessions.length) ? _c('div', {
    staticClass: "container"
  }, [_c('i', [_vm._v(_vm._s(_vm.tokens['msg_no_completed']) + " ")])]) : _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.tokens['class']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['task']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['hdr_wpm']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['date']))])])]), _c('tbody', _vm._l((_vm.sessions), function(session) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(session.cls.name))]), _c('td', [_vm._v(_vm._s(session.task.name))]), _c('td', [_vm._v(_vm._s(_vm.getWPM(session.data)))]), _c('td', [_vm._v(_vm._s(_vm._f("prettifyDate")(session.session.date)))])])
  }))])])]), _c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5029da0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/Assignments.vue
// module id = 449
// module chunks = 0